import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { IonicSlides } from '@ionic/angular';
import SwiperCore, { Autoplay, Keyboard, Pagination, SwiperOptions } from 'swiper';

SwiperCore.use([Autoplay, Keyboard, Pagination, IonicSlides]);

@Component({
  selector: 'app-carousel',
  templateUrl: 'carousel.html',
  styleUrls: ['carousel.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CarouselComponent implements OnInit {
  @Input() public carrousel: any;

  config: SwiperOptions = {
    loop: true,
    longSwipes: true,
    slidesPerView: 1,
    pagination: { clickable: true },
    autoplay: { delay: 5000, disableOnInteraction: false },
    speed: 2500
  };

  public beginning = true;
  public end = false;
  public maxHeight: number;
  private slides: any;

  constructor() {}

  ngOnInit() {
    this.getCarrouselHeight();
  }

  getCarrouselHeight() {
    const height: Array<number> = [];
    const width: Array<number> = [];
    this.carrousel.forEach( (item) => {
      height.push(item.image_height);
      width.push(item.image_width);
    });

    height.sort((a, b) => b - a);
    width.sort((a, b) => b - a);
    const userwidth = window.innerWidth;
    this.maxHeight = (userwidth * height[0]) / width[0];
  }
}
